// Packages
import create from 'zustand';
import _get from 'lodash.get';
import _set from 'lodash.set';
import _unset from 'lodash.unset';
import _uniqBy from 'lodash.uniqby';

// Utilities
import { authStore } from 'utilities/store';
import ew from 'utilities/api/elseware';

function _updateAuth() {
    const { getState } = authStore;
    getState().updateUserTimeout();
}

const useAssistedInteractionsDataStore = create((set, get) => ({
    fetched: false,

    ai: {
        _interactions: {},
        _prompts: {},
    },

    utilities: {
        interactions: {
            // Returns object
            get(id) {
                return get().ai._interactions[id] || {};
            },
            // Returns array
            getAll() {
                return Object.values(get().ai._interactions);
            },
            // Returns array
            getFromPromptKeyAndRelationId(promptKey, relation, relationId) {
                return Object.values(get().ai._interactions).filter(
                    item =>
                        item?.AI_Prompt__r?.Key__c === promptKey &&
                        item[relation] === relationId
                );
            },
        },
        prompts: {
            // Returns object
            get(id) {
                return get().ai._prompts[id] || {};
            },
            // Returns object
            getFromPromptKey(promptKey) {
                return (
                    Object.values(get().ai._prompts).find(
                        item => item.Key__c === promptKey
                    ) || {}
                );
            },
            // Returns array
            getAll() {
                return Object.values(get().ai._prompts);
            },
        },

        // Updates nested ai objects with new data
        updateAIData(path, data) {
            let ai = get().ai;
            _set(ai, `${path}[${data.Id}]`, data);
            set(() => ({
                ai,
            }));
        },
        // Updates data relations
        updateAIDataRelations(path, data) {
            let ai = get().ai;
            _set(ai, path, { ..._get(ai, path), ...data });
            set(() => ({
                ai,
            }));
        },
        // Removes data relations
        removeAIDataRelations(path, fnRelation) {
            let ai = get().ai;
            Object.values(_get(ai, path))
                .filter(fnRelation)
                .forEach(item => _unset(ai, `${path}[${item.Id}]`));
            set(() => ({
                ai,
            }));
        },
    },

    // Get ai and all sub data
    async populateAI(force) {
        if (get().fetched && !force) {
            return;
        }

        // Reset
        get().reset();

        const { data } = await ew.get({
            path: 'ai/ai',
        });

        // Update state
        set(state => ({
            ai: {
                ...state.ai,
                ...data,
            },
        }));

        // Update auth
        _updateAuth();

        // Set fetched
        set(() => ({
            fetched: true,
        }));
    },

    reset() {
        set(() => ({
            ai: {
                _interactions: {},
                _prompts: {},
            },
        }));
    },
}));

export { useAssistedInteractionsDataStore };
